import { useEffect, useState } from 'react';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

// Posição de scroll da página, throttled via requestAnimationFrame — usado
// pra mover elementos em velocidades diferentes (parallax) no hero.
// Desligado quando o usuário prefere menos movimento.
export const useParallax = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    if (prefersReducedMotion()) return;

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setScrollY(window.scrollY);
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return scrollY;
};
